/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FullCalendarStudyEvent } from 'common-typescript/types';
import { ModalService } from 'sis-common';
import { FullCalendarViewType } from '../full-calendar.types';
import { StudyEventSummaryModalComponent } from './study-event-preview/study-event-summary-modal.component';

@Component({
    selector: 'app-study-event',
    templateUrl: './study-event.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudyEventComponent {
    @Input() viewType: FullCalendarViewType.TIME_GRID_WEEK | FullCalendarViewType.DAY_GRID_MONTH;
    @Input() event: FullCalendarStudyEvent;

    constructor(private modalService: ModalService) {}

    openStudyEventPreviewModal(): void {
        this.modalService.open(StudyEventSummaryModalComponent, { event: this.event });
    }
}
